import clsx from 'clsx'

import type { PropsWithClassName } from '@fv/client-types'

import { InputGroup } from '@/components/inputs/InputGroup'

import { BolNumAvailabilityAdornment } from '../bol/BolNumAvailabilityAdornment'

type Props = {
  value: string
  onChange: (value: string) => void
  loadId?: string
}

export const ShipmentBolFormField = ({
  className,
  value,
  onChange,
  loadId,
}: PropsWithClassName<Props>) => {
  return (
    <InputGroup
      className={clsx(className, 'relative')}
      inputType="text"
      inputProps={{
        maxLength: 50,
        onChange: e => {
          onChange(e.target.value)
        },
        name: 'bol',
        value,
      }}
      label="BOL#"
      helpText="Enter your own BOL# or leave blank and Freightview will assign one for you."
      endContent={
        <div className="absolute top-0 right-0 h-full flex items-center px-2 z-[9999]">
          <BolNumAvailabilityAdornment bolNumber={value} loadId={loadId} />
        </div>
      }
    />
  )
}
